<template>
	<div class="col-md-12">
		<b-alert
			:variant="alert.type"
			dismissible
			fade
			:show="alert.show"
			@dismissed="alert.show=false"
		>{{ alert.message }}</b-alert>
		<div class="card">
			<div class="card-header">
				<h4
					class="float-left mt-2 mb-0"
				>Shippingservice-Preselection {{ readOnly ? '(read only)' : '' }}</h4>
				<button
					v-if="!readOnly"
					type="button"
					class="btn btn-secondary btn-md ml-1 float-right"
					@click="createItem()"
				>
					<span class="icon icon-plus"></span>
				</button>
				<b-form-select
					class="float-right col-md-1 mx-1"
					id="selectShippingType"
					:options="shippingTypes"
					v-model="selectedShippingType"
					:disabled="pendingChanges"
				></b-form-select>
				<b-form-select
					class="float-right col-md-1 mx-1"
					id="selectCountry"
					:options="countries"
					v-model="selectedCountryId"
					:disabled="pendingChanges"
				></b-form-select>
			</div>

			<div class="card-body">
				<table class="table-editable table table-hover">
					<tr>
						<th class="text-center">Gewicht (Mat netto) bis</th>
						<!-- unsigned int -->
						<th class="text-center">VK bis</th>
						<!-- unsigned float  -->

						<th colspan="2" class="text-center bg-light">Kombination: Gewicht bis / VK bis</th>
						<!-- uns. float combinedToVK oversizedForbidden-->
						<th class="text-center">Oversized Verboten</th>
						<th class="text-center">Versanddienstleister</th>
						<th></th>
					</tr>
					<tr
						v-for="(item, itr) in items"
						v-bind:key="itr"
						v-bind:style="{'border-bottom': (itr < (items.length - 1) && items[itr].oversizedForbidden && !items[itr+1].oversizedForbidden) ? 'solid 2px black' : '1px'}"
					>
						<td>
							<div class="input-group">
								<input
									type="text"
									class="form-control"
									required
									v-model="item.toWeight"
									:disabled="readOnly"
								/>
								<div class="input-group-append mb-auto">
									<span class="input-group-text">g</span>
								</div>
							</div>
						</td>

						<td>
							<div class="input-group">
								<input type="text" class="form-control" required v-model="item.toVK" :disabled="readOnly" />
								<div class="input-group-append mb-auto">
									<span class="input-group-text">€</span>
								</div>
							</div>
						</td>

						<td class="bg-light">
							<div class="input-group">
								<input
									type="text"
									class="form-control"
									required
									v-model="item.combinedToWeight"
									:disabled="readOnly"
								/>
								<div class="input-group-append mb-auto">
									<span class="input-group-text">g</span>
								</div>
							</div>
						</td>

						<td class="bg-light">
							<div class="input-group">
								<input
									type="text"
									class="form-control"
									required
									v-model="item.combinedToVK"
									:disabled="readOnly"
								/>
								<div class="input-group-append mb-auto">
									<span class="input-group-text">€</span>
								</div>
							</div>
						</td>

						<td v-if="!readOnly">
							<input
								v-if="(((itr != 0 && items[itr].oversizedForbidden == items[itr - 1].oversizedForbidden) || (itr == 0 && items[itr].oversizedForbidden))
								&& ((itr != items.length - 1 && items[itr].oversizedForbidden == items[itr + 1].oversizedForbidden) || (itr == items.length - 1 && !items[itr].oversizedForbidden)) 
							)"
								type="checkbox"
								class="form-control"
								value="1"
								required
								v-model="item.oversizedForbidden"
								disabled
							/>
							<input
								v-else
								type="checkbox"
								class="form-control"
								value="1"
								required
								v-model="item.oversizedForbidden"
							/>
						</td>
						<td v-else>
							<input
								type="checkbox"
								class="form-control"
								value="1"
								required
								disabled
								v-model="item.oversizedForbidden"
							/>
						</td>

						<td>
							<b-form-select
								id="selectCountry"
								:options="shippingServices"
								v-bind:value="item.shippingService"
								v-model="item.shippingService"
								:disabled="readOnly"
							></b-form-select>
						</td>

						<td v-if="!readOnly">
							<button type="button" class="btn btn-md float-right" @click="deleteItem(itr)">
								<span class="icon icon-bin"></span>
							</button>
						</td>
					</tr>
				</table>

				<button
					v-if="!readOnly"
					type="button"
					class="btn btn-primary float-right"
					@click="save()"
				>Speichern</button>
			</div>
		</div>

		<div>
			<!-- modal wait dialogue -->
			<b-modal
				v-model="modalSpinnerState"
				size="sm"
				centered
				hide-footer
				hide-header
				no-close-on-esc
				no-close-on-backdrop
				dismissible
			>
				<div class="modal-body">
					<div class="text-center justify-content-between">Bitte Warten</div>
					<div class="row"></div>
					<div class="text-center justify-content-between">
						<b-spinner label="Spinning"></b-spinner>
					</div>
				</div>
			</b-modal>
		</div>
	</div>
</template>
<script>
export default {
	props: [ "passedCountries" ],
	data() {
		return {
			authorization: { manager: false },
			items: [],
			nextSelectionIndexValue: 0, //the index  for a given rule. e.g. fuer DE: Max{items s.d. items.countryIso == 'DE'} + 1
			countries: {},
			selectedCountryId: 1,
			selectedShippingType: "0",
			modalSpinnerState: false,
			shippingTypes: {
				0: "Allgemein",
				2: "Express"
			},
			shippingServices: {
				0: "Deutsche Post Untracked",
				1: "Deutsche Post Einschreiben",
				2: "DHL Paket",
				3: "FedEx",
				4: "UPS",
				5: "DHL Paket FSK",
				6: "DHL World Express",
				7: "Deutsche Post Trackable (RFID)",
				11: "Spring Paket",
				12: "Spring Einschreiben",
				13: "Spring Trackable (RFID)",
				14: "Spring Untracked",
				15: "Spring Trackable (R)",
				16: "DHL Economy Express"
			},
			//Alert
			alert: {
				show: false,
				message: null,
				type: null
			},
			alertSaveSwitch: false,
			pendingChanges: false,

		};
	},
	watch: {
		selectedShippingType: function(nv, ov) {
			this.loadItems();
		},
		selectedCountryId: function(nv, ov) {
			this.loadItems();
		},
		items: {
			handler: function(nv, ov) {
				this.pendingChanges = true;
			},
			deep: true
		}
	},
	methods: {
		loadItems() { // Rules are not passed to the view, they are loaded dynamically (need to be reloaded after rule has been changed):
			this.modalSpinnerState = true;
			var uri = "/shippingservicepreselection/items/" + this.selectedCountryId + "/" + this.selectedShippingType;
			axios
				.get(uri)
				.then(response => {
					this.items = response.data;
					this.nextSelectionIndexValue = 0;
					for (let item of this.items) {
						if (item.selectionIndex >= this.nextSelectionIndexValue) {
							this.nextSelectionIndexValue = item.selectionIndex + 1;
						}
					}
					Vue.nextTick(() => {
						this.pendingChanges = false;
						this.modalSpinnerState = false;
					});
					// console.log("Items loaded.");
					if (!this.alertSaveSwitch) {
						this.showAlert("success", "Laden der Daten erfolgreich.");
					}
				})
				.catch(error => {
					console.dir(error);
					this.modalSpinnerState = false;
					this.showAlert("danger", "Laden der Daten fehlgeschlagen.");
				});
		},

		showAlert(type, message) {
			this.alert = {
				type: type,
				message: message,
				show: true
			};

			setTimeout(() => {
				this.alert.show = false;
			}, 5000);
		},

		save() {
			// sanity check all input for all rules
			for (let item of this.items) {
				if (_.isString(item.toVK)) {
					item.toVK = item.toVK.replace(",", ".");
				}
				if (_.isString(item.toWeight)) {
					item.toWeight = item.toWeight.replace(",", ".");
				}
				if (_.isString(item.combinedToWeight)) {
					item.combinedToWeight = item.combinedToWeight.replace(",", ".");
				}
				if (_.isString(item.combinedToVK)) {
					item.combinedToVK = item.combinedToVK.replace(",", ".");
				}

				if (item.oversizedForbidden == "") item.oversizedForbidden = 0;

				if (item.shippingType == 0 || item.shippingType == "0") {
					item.shippingType = null;
				}

				//replace shippingService with index:
				//item.shippingService = this.shippingServices.findIndex((v) => {return v.shippingService == item.shippingService)});
			}
			this.modalSpinnerState = true;
			axios.post("/shippingservicepreselection", this.items)
				.then(() => {
					this.showAlert("success", "Speichern erfolgreich");
					this.alertSaveSwitch = true;
					this.loadItems();
					this.modalSpinnerState = false;
				})
				.catch(error => {
					this.modalSpinnerState = false;
					this.showAlert(
						"danger",
						"Änderungen wurden aufgrund eines Fehlers nicht gespeichert. Drücken Sie speichern um es erneut zu versuchen."
					);
				});
			console.groupEnd();
		},

		deleteItem(itr) {
			if (confirm("Wirklich löschen?")) {
				if (this.items[itr].id == null) {
					this.items.splice(itr, 1);
				} else {
					this.modalSpinnerState = true;
					axios.post(
							"shippingservicepreselection/" + this.items[itr].id + "/remove",
							null
						).then(() => {
							this.items.splice(itr, 1);
							this.modalSpinnerState = false;
							this.showAlert("success", "Löschvorgang erfolgreich.");
						}).catch(error => {
							this.modalSpinnerState = false;
							this.showAlert("danger", "Löschvorgang fehlgeschlagen.");
							console.dir(error);
						});
				}
			}
		},

		createItem() {
			//determine next SelectionIndex:
			var max = 0;
			for (let item of this.items) {
				if (max < item.selectionIndex) {
					max = item.selectionIndex;
				}
			}
			this.nextSelectionIndexValue = max + 1;

			this.items.push({
				id: null,
				countryId: this.selectedCountryId,
				shippingType: this.selectedShippingType,
				selectionIndex: this.nextSelectionIndexValue,
				toWeight: "",
				toVK: "",
				combinedToWeight: "",
				combinedToVK: "",
				oversizedForbidden: 0,
				shippingService: 0
			});
			console.log(this.items);
			this.nextSelectionIndexValue++;
		}
	},
	created() {
		axios.get('/user/authorization').then( response => {
			this.authorization = response.data;
			this.readOnly = (!this.authorization.manager);
		}).catch( error => {
			alert("Kann Berechtigungsstufen nicht laden.");
		});

		for (let country of this.passedCountries) {
			console.log(country.countryName);
			this.countries[country.id] = country.countryName;
		}
	},
	mounted() {
		console.log("Shipping Serive Preselection Editor mounted.");
		this.loadItems();
	}
};
</script>
